import VerticalLayout from 'src/components/VerticalLayout'
import Entities from '../pages/admin/entities/list'
import EntityDetail from '../pages/admin/entities/detail'
import Divistions from '../pages/admin/divisions'

const adminRoutes = [
    {
        path: '/admin/entity-management/entities/:entityId/institutes/:instituteId/divisions',
        component: Divistions,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['wb', 'cm', 'gd', 'tp'],
        features: []
    },
    {
        path: '/admin/entity-management/entities/:entityId/detail',
        component: EntityDetail,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['wb', 'cm', 'gd', 'tp'],
        features: []
    },
    {
        path: '/admin/entity-management/entities',
        component: Entities,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['wb', 'cm', 'gd', 'tp'],
        features: []
    }
]

export default adminRoutes

export { adminRoutes }
